import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { SuccessFetchListResponse } from "@/services/api";
import { UseDataTableOptions } from "@/types/dataTableSettings";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

export function useLocalListQuery<T extends { id: string }>(
  queryKeyName: string | string[],
  items: T[],
  options: Pick<UseDataTableOptions<T>, "filters" | "sorting">,
): UseQueryResult<SuccessFetchListResponse<T>> {
  const queryKey = useDynamicQueryParams(queryKeyName, options);
  return useQuery({
    queryKey,
    queryFn: (): Promise<SuccessFetchListResponse<T>> =>
      Promise.resolve({ items, count: items.length }),
    staleTime: 0,
    gcTime: 0,
  });
}
